
// import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Head from './Head.jsx';
import Services from './Services.jsx';
import Prices from './Prices.jsx';
import Projects from './Projects.jsx';
import Contacts from './Contacts.jsx';
import Home from './Home.jsx';
import Blog from './Blog.jsx';
import BlogPage from './BlogPage.jsx';
import Footer from './Footer.jsx';
import './css/App.css';



function HomePage() {

  return (
    <>
      <Home />
      <Services />
      <Prices />
      <Projects />
      <Contacts />
    </>
  );
}

function App() {

  return (
    <BrowserRouter>
      <Head />
      <div className="App">
        {/* Routes */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/e-shop-flower-plants" element={<BlogPage />} />
          <Route path="/blog/crm-sistemata-na-max-group-events" element={<BlogPage />} />
          <Route path="/blog/onlain-magazini-za-razsadi-rasteniq-i-ovoshtni-durveta" element={<BlogPage />} />
          <Route path="/blog/esteta-design-pregradni-steni-wc-kabini" element={<BlogPage />} />
          <Route path="/blog/erp-sistemata-na-max-group-events" element={<BlogPage />} />
          <Route path="/blog/sacp" element={<BlogPage />} />
          <Route path="/blog/bluebreeze-travel" element={<BlogPage />} />
          <Route path="/blog/martina-petkova" element={<BlogPage />} />
          <Route path="/blog/vit" element={<BlogPage />} />
          <Route path="/blog/avm-consult" element={<BlogPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
